export interface FormFieldProps {
  id: string;
  label?: string;
  width?: string;
  placeholder?: string;
  placeHolder?: string;
  disabled?: boolean;
  required?: boolean;
  blurFilter?: boolean;
  checkLabel?: string;
  disableBackground?: string;
  isRequired?: boolean;
  info?: any;
  isNonMarginTop?: boolean;
  isNonMarginBottom?: boolean;
  // suggestions?: string[] | any,
  marginTopVal?: any;
  heightVal?: string;
  display?: string;
  editReadOnly?: boolean;
  disablePast?: boolean;
  multiline?: boolean;
  prefixIcon?: string;
  countryCode?: string;
  iconCalender?: string;
  labelPlacement?: "end" | "start" | "top" | "bottom" | string;
  inputRef?: React.Ref<any>;
  marginLeftCountryCode?: string;
  marginTopCountryCode?: string;
  lblBackgroundColor?: string;
  disableTextFillColor?: boolean;
  placeholderValue?: Array<{ placeholder: string; label: string }>;
  tooltipText?: string;
  counterBox?: string;
  counterSign?: string;
  counterWidth?: string;
  counterHeight?: string;
  flexDirection?: string | any;
  onIncrement?: () => void;
  onDecrement?: () => void;
  minDate?: Date;
  maxDate?: Date;
  minTime?: Date;
  maxTime?: Date;
  type?: string;
  minRows?: number;
  maxRows?: number;
  maxValue?: number;
  md?: number;
  firstColmd?: number;
  min?: number;
  max?: number;
  isRounded?: boolean;
  maxLength?: any;
  textInfo?: string;
  onCountryCodeChange?: (code: string) => void; // Make it optional
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  onFocus?: (e: any) => void;
  onDelete?: () => void;
  onMouseUp?: () => void;
  onKeyUp?: () => void;
  inGrid?: boolean;
  inSingleGridForm?: boolean;
  istextUppercase?: boolean;
  onPaste?: (e: any) => void;
  GridLabelStyle?: {
    height?: string;
  };
  GridFieldStyle?: {
    marginTop?: string;
    marginLeft?: string;
    paddingLeft?: string;
    paddingRight?: string;
    paddingTop?: string;
    paddingBottom?: string;
    border?: string;
    borderRadius?: string;
    boxShadow?: string;
  };
  InputLabelProps?: {
    shrink?: boolean;
    sx?: {
      color?: string;
      fontWeight?: number;
      fontSize?: string;
      textWrap?: string;
    };
  };
  InputProps?: {
    maxLength?: any;
    sx: {
      height?: string;
      padding?: string;
      width?: string;
      marginTop?: string;
      color?: string;
      fontSize?: string;
    };
    autocomplete?: any;
  };
  inputProps?: {
    maxLength?: any;
    style?: {
      height?: string;
      padding?: string;
    };
  };
  autoFocus?: boolean;
  error?: boolean;
  helperText?: string;
  // checkbox field
  checked?: boolean;
  // select field
  options?: any[];
  suggestions?: string[];
  radioOptions?: Array<string | { label: string; value: string | boolean }>;
  defaultValue?: any; // Default value for the select field
  selectedValues?: string[];
  value?: any;
  readOnly?: any;
  renewsOn?: any;
  onKeyDown?: any;
  isFlexField?: boolean;
  row?: boolean; // Additional property for RadioGroup
  editorConfig?: {
    hideFontControls?: boolean;
    showPreview?: boolean;
    showFormattingToggle?: boolean;
    showEditToggle?: boolean;
    disableEnter?: boolean;
  };
}

export const formFields = {
  usernameOrEmail: {
    id: "usernameOrEmail",
    required: true,
    placeholder: "Username/Email",
    helperText: "Please enter correct user name/email",
  },
  password: {
    id: "password",
    placeholder: "Password",
    type: "password",
    required: true,
    helperText: "Please enter the password",
  },
  isToLogoutAllDevices: {
    id: "isToLogoutAllDevices",
    type: "checkbox",
    required: false,
  },
  isTerminateAllSessions: {
    id: "isTerminateAllSessions",
    type: "checkbox",
    required: false,
  },

  email: {
    id: "email",
    required: true,
    placeholder: "Email",
    helperText: "Please enter correct user email",
  },
};

export const FormFieldNames = {
  EMAIL: "email",
};
